import React, { Fragment, useContext }  from "react";
import propTypes from "prop-types";
import { EditableGroupContext } from "../../EditableGroup/EditableGroup";

const AddLabel: React.FunctionComponent<{
  label: string;
  onClick: () => void;
}> = (props) => {

  const state = useContext(EditableGroupContext);
  if (state.isEditing === true) {
      return <div>
        <div onClick={()=>props.onClick()} style={{color:"#333", padding:10, textDecoration:"underline", cursor:"pointer"}}>{props.label}</div>
      </div>
  }
  return <Fragment />
};

AddLabel.propTypes = {
  label: propTypes.string.isRequired,
  onClick: propTypes.func.isRequired,
};

export default AddLabel;
